import spinnerImgPurple from "@assets/images/sand-glass-purple.svg";
import spinnerImgGreen from "@assets/images/sand-glass.svg";
import { Dialog, Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    root: {
      width: "560px",
      padding: "48px 24px 46px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    caption: {
      color: theme.palette.grey[900],
      marginBottom: "1.2rem"
    },
    spinnerContainer: {
      position: "relative",
      margin: "0 0 80px"
    },
    spinnerGreen: {
      position: "absolute",
      animation: `$spin 0.9s ease-in-out infinite alternate`
    },
    "@keyframes spin": {
      "0%": { transform: "rotate(0deg)" },
      "20%": { transform: "rotate(0deg)" },
      "80%": { transform: "rotate(180deg)" },
      "100%": { transform: "rotate(180deg)" }
    },
    spinnerPurple: {
      position: "absolute",
      animation: `$spinFade 0.9s ease-in-out infinite alternate`
    },
    "@keyframes spinFade": {
      "0%": { transform: "rotate(180deg)", opacity: 0 },
      "20%": { transform: "rotate(180deg)", opacity: 0 },
      "80%": { transform: "rotate(360deg)", opacity: 1 },
      "100%": { transform: "rotate(360deg)", opacity: 1 }
    }
  }),
  { name: "SubmitOrder" }
);

interface DialogSubmitOrderProps {
  open: boolean;
  onClose: () => void;
}

const DialogSubmitOrder: React.FC<DialogSubmitOrderProps> = ({
  open,
  onClose
}) => {
  const classes = useStyles();
  return (
    <Dialog open={open} onClose={onClose}>
      <Paper className={classes.root}>
        <div className={classes.spinnerContainer}>
          <img
            src={spinnerImgGreen}
            className={classes.spinnerGreen}
            alt="spinner"
          />
          <img
            src={spinnerImgPurple}
            className={classes.spinnerPurple}
            alt="spinner"
          />
        </div>
        <MyTypography variant="h6" className={classes.caption}>
          The system is processing orders...
        </MyTypography>
        <MyTypography variant="body2">
          กรุณาอย่า refresh หน้าจอ เมื่อแก้ไขใบสั่งซื้อสำเร็จ
          ท่านสามารถตรวจสอบใบสั่งซื้อได้ที่เมนู Search Order/List of Sales Order
        </MyTypography>
      </Paper>
    </Dialog>
  );
};

export default DialogSubmitOrder;
